module.exports = __webpack_public_path__ + "static/media/icon-left.486d9b19.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/icon-left.svg
// module id = 135
// module chunks = 0